import React from 'react';

import { FormHelperText, TextField } from '@mui/material';

function MarkdownEditor(props) {
  const { options, helperText: helper } = props;
  const helperText = helper ?? (options && options.helperText ? options.helperText : '');
  const hideLabel = props?.registry?.formContext?.hideLabel || false;
  const label = props.hideLabel || hideLabel ? props.title : props.label || props.title;

  return (
    <div>
      <TextField
        label={label}
        value={props.value || ''}
        onChange={(e) => props.onChange?.(e.target.value)}
        onBlur={(e) => props.onBlur?.(e.target.value)}
        disabled={props.readonly || props.disabled}
        error={props.error}
        multiline
        minRows={6}
        fullWidth
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
}

export default MarkdownEditor;
